<div style="width: 100%; height: 100%">
	<div [style.width.%]="100" [style.margin]="0" [style.height.%]="100" id="wordCloudContainer"></div>
</div>
